import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, useEffect, useRef } from 'react';
import { useLoadWidget, propsBoolean, propsObject } from '../utils';
import { SgwtWidgetContext } from '../context';
const name = 'sgwt-help-center';
export const SgwtHelpCenter = ({ additionalMessageInformation, allowScreenshot, applicationId, cmt, conversationId, debug, emailEndpoint, feedbackContext, handleVisible, i18n, introductionTour, knowledgeUrls, knowledge, language, mailSubject, messageTemplate, messageOnly, messageTopics, noConsole, noImproment, tags, unity, user, onCategoryClicked, onTopicClicked, onTourStart, id, onWidgetReady, }) => {
    const widget = useRef();
    const { infrastructure, registerWidget } = useContext(SgwtWidgetContext);
    useLoadWidget(name, infrastructure);
    useEffect(() => {
        if (!!widget.current) {
            onWidgetReady?.(widget.current);
            registerWidget('sgwtHelpCenter', widget.current);
        }
    }, [widget, onWidgetReady, registerWidget]);
    // ---- [EVENTS] ----
    useEffect(() => {
        const eventName = `${name}--start-introduction-tour`;
        const startTour = () => onTourStart?.();
        document.addEventListener(eventName, startTour);
        return () => document.removeEventListener(eventName, startTour);
    }, [onTourStart]);
    useEffect(() => {
        const eventName = `${name}--category`;
        const categoryClicked = (event) => onCategoryClicked?.(event.detail);
        document.addEventListener(eventName, categoryClicked);
        return () => document.removeEventListener(eventName, categoryClicked);
    }, [onCategoryClicked]);
    useEffect(() => {
        const eventName = `${name}--topic`;
        const topicClicked = (event) => onTopicClicked?.(event.detail);
        document.addEventListener(eventName, topicClicked);
        return () => document.removeEventListener(eventName, topicClicked);
    }, [onTopicClicked]);
    return (_jsx("aside", { children: _jsx("sgwt-help-center", { ref: widget, id: id, "additional-message-information": propsObject(additionalMessageInformation), "allow-screenshot": propsBoolean(allowScreenshot), "application-id": applicationId, cmt: propsObject(cmt), "conversation-id": conversationId, debug: propsBoolean(debug), "email-endpoint": emailEndpoint, "feedback-context": feedbackContext, "handle-visible": propsBoolean(handleVisible), i18n: propsObject(i18n), impulse: propsObject(unity), unity: propsObject(unity), "introduction-tour": propsBoolean(introductionTour), "knowledge-urls": propsObject(knowledgeUrls), knowledge: propsObject(knowledge), language: language, "mail-subject": mailSubject, "message-template": messageTemplate, "message-only": propsBoolean(messageOnly), "message-topics": propsObject(messageTopics), "no-console": propsBoolean(noConsole), "no-improment": propsBoolean(noImproment), tags: propsObject(tags), user: propsObject(user), "sg-connect-support": "sg-connect-v2" }) }));
};
//# sourceMappingURL=SgwtHelpCenter.js.map